import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import TristrashPage from './pages/TristrashPage';
import PandoPage from './pages/PandoPage';
import LixoPage from './pages/LixoPage';
import HaloIPage from './pages/HaloIPage';
import DigitalTwinPage from './pages/DigitalTwinPage';
import CanariaPage from './pages/CanariaPage';
import ExoesqueletoPage from './pages/ExoesqueletoPage';
import RoboticaPage from './pages/RoboticaPage';
import KlinLoopPage from './pages/KlinLoopPage';
import ProyectosPage from './pages/ProyectosPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import PatentesPage from './pages/PatentesPage';
import RetosPage from './pages/RetosPage';
import EstrategiaPage from './pages/EstrategiaPage';
import ContactoPage from './pages/ContactoPage';
import EquipoPage from './pages/EquipoPage';
import EquipoDavidPage from './pages/EquipoDavidPage';
import TeamMemberPage from './pages/TeamMemberPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/en" element={<HomePage />} />

            {/* Technology / product pages */}
            <Route path="/tristrash" element={<TristrashPage />} />
            <Route path="/en/tristrash" element={<TristrashPage />} />
            <Route path="/pando" element={<PandoPage />} />
            <Route path="/en/pando" element={<PandoPage />} />
            <Route path="/lixo" element={<LixoPage />} />
            <Route path="/en/lixo" element={<LixoPage />} />
            <Route path="/halo-i" element={<HaloIPage />} />
            <Route path="/en/halo-i" element={<HaloIPage />} />
            <Route path="/digital-twin" element={<DigitalTwinPage />} />
            <Route path="/en/digital-twin" element={<DigitalTwinPage />} />
            <Route path="/canaria" element={<CanariaPage />} />
            <Route path="/en/canaria" element={<CanariaPage />} />
            <Route path="/exoesqueleto" element={<ExoesqueletoPage />} />
            <Route path="/en/exoesqueleto" element={<ExoesqueletoPage />} />
            <Route path="/robotica" element={<RoboticaPage />} />
            <Route path="/en/robotica" element={<RoboticaPage />} />
            <Route path="/klinloop" element={<KlinLoopPage />} />
            <Route path="/en/klinloop" element={<KlinLoopPage />} />

            {/* R&D funded projects portfolio */}
            <Route path="/proyectos" element={<ProyectosPage />} />
            <Route path="/en/projects" element={<ProyectosPage />} />
            <Route path="/proyectos/:slug" element={<ProjectDetailPage />} />
            <Route path="/en/projects/:slug" element={<ProjectDetailPage />} />

            {/* IP, challenges, strategy, contact */}
            <Route path="/patentes" element={<PatentesPage />} />
            <Route path="/en/patentes" element={<PatentesPage />} />
            <Route path="/retos" element={<RetosPage />} />
            <Route path="/en/challenges" element={<RetosPage />} />
            <Route path="/estrategia" element={<EstrategiaPage />} />
            <Route path="/en/strategy" element={<EstrategiaPage />} />
            <Route path="/contacto" element={<ContactoPage />} />
            <Route path="/en/contact" element={<ContactoPage />} />

            {/* Team */}
            <Route path="/equipo" element={<EquipoPage />} />
            <Route path="/en/team" element={<EquipoPage />} />
            <Route path="/equipo/david-redondo-perez" element={<EquipoDavidPage />} />
            <Route path="/en/team/david-redondo-perez" element={<EquipoDavidPage />} />
            <Route path="/equipo/:slug" element={<TeamMemberPage />} />
            <Route path="/en/team/:slug" element={<TeamMemberPage />} />

            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
